var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productBarContainer" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.loaded
          ? _c(
              "div",
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "productCat" },
                  [
                    !_vm.ingredientsSection
                      ? _c("p", { staticClass: "catHeadline" }, [
                          _vm._v(_vm._s(item.name)),
                        ])
                      : _vm._e(),
                    _vm._l(item.globalProducts, function (product, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "productContainer" },
                        [
                          _vm.windowUrl.indexOf(product.productPageLink) == -1
                            ? _c("div", [
                                _vm.showImage
                                  ? _c("div", { staticClass: "productImg" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.basedir +
                                              "/" +
                                              product.productPageLink,
                                          },
                                        },
                                        [
                                          _c("img", {
                                            directives: [
                                              {
                                                name: "lazy",
                                                rawName: "v-lazy",
                                                value:
                                                  product.imageUrl + "?w=57",
                                                expression:
                                                  "product.imageUrl+'?w=57'",
                                              },
                                            ],
                                            attrs: { alt: product.name },
                                          }),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "productDetails",
                                      _vm.showImage ? "showImage" : "",
                                    ],
                                  },
                                  [
                                    _c("a", {
                                      staticClass: "headline",
                                      attrs: {
                                        href:
                                          _vm.basedir +
                                          "/" +
                                          product.productPageLink,
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          item.name.length > 50
                                            ? product.name.slice(0, 50) + "..."
                                            : product.name
                                        ),
                                      },
                                    }),
                                    _c("span", {
                                      staticClass: "excerpt",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          product.description.trim().length >
                                            100 && _vm.showImage
                                            ? product.description
                                                .slice(0, 100)
                                                .trim() + "..."
                                            : product.description.trim()
                                        ),
                                      },
                                    }),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "readMore",
                                        attrs: {
                                          href:
                                            _vm.basedir +
                                            "/" +
                                            product.productPageLink,
                                        },
                                      },
                                      [
                                        _c("webmessage", {
                                          attrs: {
                                            searchKey: "wsm_ReadMore",
                                            text: _vm.$root.language
                                              .wsm_ReadMore,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: ["fas", "angle-right"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    !_vm.ingredientsSection ? _c("hr") : _vm._e(),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      !_vm.loaded
        ? _c(
            "div",
            _vm._l(_vm.resultNo, function (n) {
              return _c(
                "div",
                { key: n, staticClass: "loadContainer" },
                [
                  _c("br"),
                  n == 1 || n == 3
                    ? _c(
                        "vue-content-loading",
                        {
                          staticClass: "loaderHeadline",
                          attrs: {
                            rtl: true,
                            width: 20000,
                            primary: "#caedb9",
                            secondary: "#faf8f4",
                            height: 1500,
                            speed: 1,
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              x: "75",
                              y: "13",
                              rx: "4",
                              ry: "4",
                              width: "100%",
                              height: "100%",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "vue-content-loading",
                    {
                      attrs: {
                        rtl: true,
                        width: 20000,
                        primary: "#f5f2eb",
                        secondary: "#faf8f4",
                        height: 2500,
                        speed: 1,
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    {
                      staticClass: "textLoader",
                      attrs: {
                        rtl: true,
                        width: 300,
                        height: 20,
                        speed: 1,
                        primary: "#f5f2eb",
                        secondary: "#faf8f4",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    {
                      staticClass: "textLoader",
                      attrs: {
                        rtl: true,
                        width: 250,
                        height: 20,
                        speed: 1,
                        primary: "#f5f2eb",
                        secondary: "#faf8f4",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-bottom": "-8px",
                      },
                      attrs: {
                        rtl: true,
                        width: 175,
                        height: 29,
                        speed: 1,
                        primary: "#f5f2eb",
                        secondary: "#faf8f4",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]
                  ),
                  _c("br"),
                  _c("br"),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }